import * as _ from 'underscore';
import React from 'react';

import Tooltip from 'material-ui/Tooltip';
import Button from 'material-ui/Button';

import PDList from './PrescriptionDropList';

import Console from '../../../../lib/debug';

export default class PrescriptionDrop extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: false,
            emptyError: false,
            isFocused: false,
            hoverCategory: false,
            selectedCategory: {}
        };
        this.defaultWidth = 220;
        this.timeoutId = null;
        this.prescriptionPos = {
            top: 0,
            left: 0
        };
        this.selectedPrescriptions = [];
        this.itemsRef = {};
        this.prescRef = {};
    }

    componentDidUpdate() {
        if (this.props.auto && !this.autoFocused) {
            this.focus();
            this.autoFocused = true;
        }
    }

    componentWillMount() {
        if (this.props.selectedValue) {
            this.setState(() => ({
                selected: true,
                emptyError: false
            }));
        }
    }

    bodyClick = e => {
        let $srcEl = e.target;
        if (this.$parent && !this.$parent.contains($srcEl)) {
            this.close();
        }
    };

    // Calculates position of submenu
    calculatePosition(item) {
        const SUBMENU_WIDTH = 215;
        const SUBMENU_HEIGHT = 200;
        const OFFSET_SPACE = 30;
        let $item = item ? this.itemsRef[item.id] : null;
        if ($item) {
            let $parent = document.querySelector(
                '.MegaDrop-menu-outer.first.active'
            );
            let pos = $item.getBoundingClientRect();
            let parentPos = $parent.getBoundingClientRect();
            let tempLeft = parentPos.width - OFFSET_SPACE;
            let tempTop = pos.top - parentPos.top;
            let winWidth = window.innerWidth;
            let winHeight = window.innerHeight;
            let horizontalDiff =
                winWidth - (pos.left + tempLeft + SUBMENU_WIDTH);
            let verticalDiff = winHeight - (pos.top + SUBMENU_HEIGHT);
            tempLeft =
                horizontalDiff < 0 ? tempLeft + horizontalDiff : tempLeft;
            tempTop =
                verticalDiff < 0
                    ? verticalDiff + tempTop - OFFSET_SPACE
                    : tempTop;
            this.prescriptionPos.top = tempTop - 5;
            this.prescriptionPos.left = tempLeft;
        }
    }

    close(selected) {
        let emptyError = false;
        let showErrors = this.props.exercise.abr
            ? false
            : selected
                ? false
                : this.state.selected
                    ? false
                    : true;
        if (showErrors) {
            emptyError = true;
        }
        this.setState(() => ({
            isFocused: false,
            hoverCategory: false,
            selected,
            emptyError
        }));
        this.props.onClose && this.props.onClose();
    }

    focus() {
        document.body.addEventListener('click', this.bodyClick);
        if (!this.state.isFocused) {
            this.setState(() => ({
                isFocused: true,
                hoverCategory: false
            }));
            // Move window to the bottom
            this.moveMegaDrop();
            this.props.onOpen && this.props.onOpen();
        }
    }

    getCategoryPrescriptions(id) {
        let prescriptions = [];
        this.props.prescriptions.map(presc => {
            let catFound = _.find(presc.tags, { id });
            if (catFound) {
                prescriptions.push(presc);
            }
            if (id === 0 && !presc.tags.length && !presc.custom) {
                prescriptions.push(presc);
            }
        });
        return prescriptions.sort((a, b) => {
            if (a.param_count - b.param_count === 0) {
                if (a.param_1_data_1 - b.param_1_data_1 === 0) {
                    return a.param_2_data_1 - b.param_2_data_1;
                }
                return a.param_1_data_1 - b.param_1_data_1;
            }
            return a.param_count - b.param_count;
        });
    }

    getOptions() {
        let allOptions = [...this.props.categories];
        let prescriptions = this.props.prescriptions;
        allOptions.map(cat => {
            prescriptions.map(p => {
                let found = _.find(p.tags, { id: cat.id });
                if (found) {
                    cat.expand = true;
                }
            });
        });
        allOptions = _.sortBy(allOptions, item => item.title.toLowerCase());
        allOptions.unshift({
            id: 'title',
            title: 'Categories',
            category: 'title',
            fake: true
        });
        return allOptions.filter(o => o.expand);
    }

    handleCategoryEnter(item) {
        this.selectedPrescriptions = this.getCategoryPrescriptions(item.id);
        this.calculatePosition(item);
        let $item = item ? this.itemsRef[item.id] : null;
        if ($item) {
            clearTimeout(this.timeoutId);
            this.setState(() => ({
                hoverCategory: true,
                selectedCategory: item
            }));
        }
    }

    handleLeaveCategory() {
        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(() => {
            this.setState(() => ({
                hoverCategory: false,
                selectedCategory: {}
            }));
        }, 300);
    }

    handleLeavePrescription() {
        this.timeoutId = setTimeout(() => {
            this.setState(() => ({
                hoverCategory: false
            }));
        }, 300);
    }

    handlePrescriptionEnter() {
        clearTimeout(this.timeoutId);
    }

    handlePrescriptionSelect(item) {
        this.props.onSelect(item);
        this.close(true);
    }

    handleCreate() {
        this.props.onSelect({ id: 0, key: 0 }, this.state.selectedCategory);
        this.close(true);
    }

    moveMegaDrop() {
        const MD_OUTER_HEIGHT = 311;
        const AIR = 20;
        let $body = document.querySelector('html');
        let parentRect = this.$parent.getBoundingClientRect();
        let bodyHeight = $body.offsetHeight;
        let mdTop = parentRect.top;
        let mdHeight = parentRect.height + MD_OUTER_HEIGHT;
        if (bodyHeight - (mdTop + mdHeight) < 0) {
            $body.scrollTop += Math.abs(bodyHeight - (mdTop + mdHeight)) + AIR;
        }
        this.$container.scrollTop = 0;
    }

    render() {
        Console.render('designer.PrescriptionDrop');
        let { exercise } = this.props;
        let optionLabel = this.props.placeholder || null;
        let prescriptionList = null;
        let selectedValue = exercise.abr;
        let categories = this.getOptions();
        let subMenuStyle = { ...this.prescriptionPos };
        let selectedPrescriptions = [...this.selectedPrescriptions];

        if (selectedValue) {
            optionLabel = (
                <div className="MegaDrop-value">
                    <span className="MegaDrop-value-label">
                        {selectedValue}
                    </span>
                </div>
            );
        }

        if (this.state.hoverCategory) {
            prescriptionList = (
                <PDList
                    submenu={true}
                    show={this.state.isFocused}
                    items={selectedPrescriptions}
                    itemsRef={this.prescRef}
                    container={this.$containerPresc}
                    onEnterItem={this.handlePrescriptionEnter.bind(this)}
                    onSelectItem={this.handlePrescriptionSelect.bind(this)}
                />
            );
        }
        const controlClass = `MegaDrop-control MegaDrop-control-prescription${
            this.state.emptyError ? ' empty' : ''
        }`;
        return (
            <div
                className={`MegaDrop-parent ${
                    this.state.isFocused ? 'active' : ''
                }${this.props.disabled ? 'disabled' : ''}`}
                ref={el => {
                    this.$parent = el;
                }}
            >
                <div className="MegaDrop">
                    <div
                        className={controlClass}
                        onClick={this.focus.bind(this)}
                    >
                        <div className="MegaDrop-multi-value-wrapper">
                            <div
                                className={`MegaDrop-value${
                                    this.props.exercise.abr !== ''
                                        ? ' MegaDrop-item-selected'
                                        : ''
                                }`}
                            >
                                <div className="MegaDrop-value-label">
                                    {optionLabel}
                                </div>
                            </div>
                        </div>
                        <div className="Select-arrow-zone">
                            <span className="mdi mdi-chevron-down" />
                        </div>
                    </div>
                    <div
                        className={`MegaDrop-menu-outer first${
                            this.state.isFocused ? ' active' : ''
                        }`}
                        style={{
                            display: `${
                                this.state.isFocused ? 'block' : 'none'
                            }`,
                            width: this.props.width || this.defaultWidth
                        }}
                        ref={el => (this.$dropOuterFixed = el)}
                    >
                        <div
                            style={subMenuStyle}
                            className={`MegaDrop-submenu MegaDrop-menu-outer${
                                this.state.hoverCategory ? ' active' : ''
                            }`}
                        >
                            <div
                                className="view-wrapper prescription-wrapper"
                                ref={el => {
                                    this.$containerPresc = el;
                                }}
                                onMouseLeave={this.handleLeavePrescription.bind(
                                    this
                                )}
                                onMouseEnter={this.handlePrescriptionEnter.bind(
                                    this
                                )}
                            >
                                {prescriptionList}
                            </div>
                        </div>
                        <div
                            className="view-wrapper prescription-wrapper"
                            ref={el => {
                                this.$container = el;
                            }}
                        >
                            <PDList
                                show={this.state.isFocused}
                                items={categories}
                                itemsRef={this.itemsRef}
                                container={this.$container}
                                onEnterItem={this.handleCategoryEnter.bind(
                                    this
                                )}
                                onLeaveItems={this.handleLeaveCategory.bind(
                                    this
                                )}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
